module.exports = __webpack_public_path__ + "a7f61bab01800e41cf51756bedc0e9da.svg";